import { createFileRoute } from '@tanstack/react-router'
import { TemplateVersionDetailPage } from '@/features/admin/templates/detail/version-detail'

export const Route = createFileRoute(
  '/_admin/admin/templates/$templateId/$versionId/'
)({
  component: TemplateVersionDetailPage,
})
